import React, {useState,useRef, useEffect } from 'react';
import CustomButtoncolor from "../custom-button/customColorButton";
import {Autocomplete, Avatar, Box, Button, Checkbox, FormControlLabel, Grid, Hidden, Radio, Stack, Tab, Tabs, TextField, Typography} from "@mui/material";
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import CustomModal from "../modal/customModal";
import moment from "moment/moment";
import {
    getCrmAppointmentHolidays,
    getCrmAppointmentSchedule,
    rescheduleAppointment
} from "../../store/crm/appointment/book-appointment";
import {useDispatch, useSelector} from "react-redux";
import Loader from "../loader/loader";
import CancelIcon from '@mui/icons-material/Cancel';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { IconButton } from '@mui/material';
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AppointmentTime from "../../pages/crm/appointment/add-appointment/appointmentTime";
import {MySwal, convertTimeToMinutes, successConfirmation} from "../../services/utills";
import {mySwalButton, mySwalButtonCancel, mySwalButtonYes} from "./CardAppointment";
import CustomButton from "../custom-button/customButton";
import {getAllAppointment, getAppointmentDetails, getAppointmentHistory, getAppointmentcalender} from "../../store/crm/appointment";
import Waveloading from '../../pages/loading/Waveloading';
import { Navigate, useNavigate } from 'react-router';
import { getCRMCustomerBookingsDetails } from '../../store/crm/crm';
import { appointmentCallLogData } from '../../store/crm/call-log';
import CRMPage from '../../pages/crm/crmpage/CRMPage';
import { getStaff } from '../../store/crm/staffs';
import { getProviderStaff } from '../../store/crm/staff';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import Customcolorbtn from '../custom-button/customeColorCalender';
import toast from 'react-hot-toast';
import AddNotesModal from '../modal/AddNotesModal';

const AppointmentCalender = ({ isbtn, triggerReload,appointment,isConfirm, iscall, isBooking, isAppointment,isRequested,isMouseEnter,setIsMouseEnter,fetchAppointment, fwidth,onRescheduleSuccess,startDate,endTime, isCalender, panelMode, onPanelClose, onActionStart, onActionEnd, hideFooter, onSelectionChange, onBack}) => {
    const [rescheduleModal, setRescheduleModal] = useState(false)
    const [loading, setLoading] = useState(false)
    const [selectedFinalDate,setSelectedFinalDate] = useState(null)
    const [selectedTime,setSelectedTime] = useState(null) 
    const navigate = useNavigate()
      const [selectedStaff, setSelectedStaff] = useState(null)

    const [apiValue, setApiValue] = useState(1);
    const [noteInlineView, setNoteInlineView] = useState(false);  
    const crmStaffStore = useSelector(state => state?.crmStaffStore)
    const {crmStaffs = []} = crmStaffStore
    const handleCheckboxChange = (event) => {
        const checked = event.target.checked;
        setApiValue(checked ? 1 : 0);
      };

 

      //console.log("resecdule data coming",appointment)
 
      
      const dispatch = useDispatch()  
    useEffect(() => {
        if (appointment?.staff?.id && crmStaffs?.length > 0) {
          const matched = crmStaffs.find((staff) => staff.id === appointment.staff.id);
          if (matched) {
            setSelectedStaff(matched);
          }
        }
      }, [appointment, crmStaffs]);
      
      const handleStaffSelection = (staff) => {
        if (selectedStaff?.id === staff.id) {
          setSelectedStaff(null);
          //console.log("staff",selectedStaff?.id)
        } else {
          setSelectedStaff(staff);
          //console.log("staff",selectedStaff?.id)
        //   scrollRef.current?.scrollIntoView({ behavior: "smooth" });
        }
      };
    const getAppointmentHoliday = async (date, staff) => {
        setLoading(true) 
        let finalDate = moment(date).format('YYYY-MM-DD')
        // setSelectedFinalDate(finalDate)
        if (finalDate) {
            let finalData = {
                date: finalDate
            }
          /*  if (staff?.id) {
                finalData['staff_id'] = staff?.id
            }*/
            await dispatch(getCrmAppointmentHolidays(finalData))
        }

        setLoading(false)      

    }
    const getAppointmentSchedule = async (date) => {

        setLoading(true)
        let serviceIds = []
        appointment?.services.forEach((item) => {
            serviceIds.push(item?.id)
        })


        let finalDate = moment(date).format('YYYY-MM-DD')

        setSelectedFinalDate(finalDate)
        setSelectedTime(null)
        let finalData = {
            date: finalDate,
            service_ids: serviceIds
        }

        await dispatch(getCrmAppointmentSchedule(finalData))
  
        setLoading(false)           
       
    }    
 
    const handleReschedule = async () => {
        let confirm = await MySwal.fire({ 
            // icon: 'question',   
            title: 'Reschedule?',
           
            showConfirmButton: false,
            customClass: {
                icon: 'custom-icon-size',
                popup: 'custom-popup-shadow',
                closeButton: 'custom-close-button',
              },
            showCloseButton: true,
            html:    <Stack
                  sx={{ width: '100%', justifyContent: "center", alignItems: "center" }}
                  direction={{ xs: 'column', lg: 'row',sm:"row" }}
                  spacing={2}
                >
                  <Button sx={{...mySwalButtonYes, background: "#27AE60", color: "#fff", border: "1px solid #27AE60", boxShadow: "none", "&:hover": {background: "#219653", color: "#fff", border: "1px solid #27AE60", boxShadow: "none"}}} onClick={() => MySwal.clickConfirm()}>Yes</Button>
                  <Button sx={{...mySwalButtonCancel, backgroundColor: "#EB5757", color: "#fff", border: "1px solid #EB5757", boxShadow: "none", "&:hover": {backgroundColor: "#fff", color: "#EB5757", border: "1px solid #EB5757", boxShadow: "none"}}} onClick={() => MySwal.close()}>No</Button>
                </Stack> 
        })
        if (!!confirm?.isConfirmed) {
            if (appointment?.date && appointment?.end_time && appointment?.start_time) {
                let givenDate = moment(appointment?.date);
                let today = moment(new Date());

                    setLoading(true)
                   
                    await getAppointmentHoliday(appointment?.date, appointment?.staff)
                    await getAppointmentSchedule(appointment?.date)
                    dispatch(getProviderStaff())
                    setSelectedFinalDate(appointment?.date)
                      
                    setLoading(false)
                    setRescheduleModal(true)
             
            }else {
                setRescheduleModal(true)
            }
        }
    }
    const handelRescheduleClick = async () => {
        if (panelMode) {
            const finalData = {
                staff_id: selectedStaff?.id || null,
                booking_id: appointment?.id,
                date: selectedFinalDate,
                start_time: selectedTime?.start_time,
                end_time: selectedTime?.end_time,
                is_email_send: apiValue,
            }
            onActionStart?.()
            dispatch(rescheduleAppointment(finalData)).then(async ({payload}) => {
                if (payload?.success === "true") {
                    if (isCalender) { await dispatch(getAppointmentcalender(appointment?.id)) }
                }
                onActionEnd?.(payload?.success === "true" ? "Appointment rescheduled successfully!" : null)
            })
            return
        }
        setRescheduleModal(false)
        setLoading(true)
        let finalData = {
            staff_id: selectedStaff?.id || null,
            booking_id:appointment?.id,
            date:selectedFinalDate,
            start_time:selectedTime?.start_time,
            end_time:selectedTime?.end_time,
            is_email_send:apiValue,
        }
        let {payload} = await dispatch(rescheduleAppointment(finalData))

        if (payload?.success === "true"){
          if (isCalender){
            await dispatch(getAppointmentcalender(appointment?.id))
          }
          if(isAppointment){
            await dispatch(getAppointmentDetails(appointment?.id))
            await dispatch(getAllAppointment({start_date:"null",end_date:"null"}))

          }
           //call when reschudle from booking history
          if(isBooking){
            await dispatch (getAppointmentHistory({
              user_id:appointment?.customer?.id,type:'Appointments'
          }))
          await dispatch (getCRMCustomerBookingsDetails({
              id:appointment?.customer?.id,
              type:'Appointments'
          }))
          }
          if(iscall){
            await dispatch(appointmentCallLogData());
          }
            // await dispatch(getAppointmentDetails(appointment?.id))
            // await dispatch (getAppointmentHistory({
            //     user_id:appointment?.customer?.id,type:'Appointments'
            // }))
            // await dispatch (getCRMCustomerBookingsDetails({
            //     id:appointment?.customer?.id,
            //     type:'Appointments'
            // }))

            // await dispatch(getAllAppointment({start_date:"null",end_date:"null"}))
            // await dispatch(appointmentCallLogData());

           
         
            setLoading(false)  

           toast.success("Appointment rescheduled successfully!")
             if(triggerReload){
                triggerReload()
             }

            if (panelMode) { onPanelClose?.(); } else { setRescheduleModal(false); }
            if (onRescheduleSuccess) {
                onRescheduleSuccess();
              }
        }else {
            setLoading(false)
        }
    }
    const handleTimeSelect = (slotsArray, startTime) => {
        // Implement your logic for handling time slot selection here
        
        // Scroll to the Reschedule Appointment button
        // if (rescheduleButtonRef.current) {
        //   rescheduleButtonRef.current.scrollIntoView({ behavior: 'smooth' });
        // }
      };
       
      const rescheduleButtonRef = useRef(null);
      const staffStripRef = useRef(null);

      useEffect(() => {
        if (panelMode && appointment?.date) {
            dispatch(getProviderStaff())
            getAppointmentHoliday(appointment.date, appointment.staff)
            getAppointmentSchedule(appointment.date)
        }
      }, [])

      // hideFooter mode: notify parent whenever the user picks a new date / time / staff
      // so the parent can stage the change (e.g. include it in its own submit).
      useEffect(() => {
        if (!hideFooter || !onSelectionChange) return;
        if (!selectedFinalDate || !selectedTime?.start_time) return;
        onSelectionChange({
            date: selectedFinalDate,
            start_time: selectedTime?.start_time,
            end_time: selectedTime?.end_time,
            staff: selectedStaff,
        });
      }, [hideFooter, selectedFinalDate, selectedTime?.start_time, selectedTime?.end_time, selectedStaff?.id]);

      // Function to execute scrolling to the reschedule button
      const executeScroll = () => {
        setTimeout(() => {
            rescheduleButtonRef.current?.scrollIntoView({ behavior: 'smooth' });
        }, 500);
      };


      
          

    if (panelMode) {
        const canSubmit = !!selectedTime?.start_time;
        if (noteInlineView) {
            return (
                <Box sx={{
                    height:'100%',
                    width:'100%',
                    background:'#fff',
                    display:'flex',
                    flexDirection:'column',
                    overflow:'hidden',
                }}>
                    <AddNotesModal
                        appointmentDetails={appointment}
                        panelMode
                        onPanelClose={() => setNoteInlineView(false)}
                        onCloseAll={() => { setNoteInlineView(false); onPanelClose?.(); }}
                    />
                </Box>
            );
        }
        const formatTimeRange = () => {
            if (selectedTime?.start_time && selectedTime?.end_time) {
                return `${selectedTime.start_time} – ${selectedTime.end_time}`;
            }
            if (appointment?.start_time && appointment?.end_time) {
                return `${appointment.start_time} – ${appointment.end_time}`;
            }
            return '';
        };
        const headerSubtitle = (() => {
            const dateStr = selectedFinalDate
                ? moment(selectedFinalDate).format('MMM D')
                : (appointment?.date ? moment(appointment.date).format('MMM D') : null);
            const timeStr = formatTimeRange();
            if (dateStr && timeStr) return `Currently ${dateStr} · ${timeStr}`;
            if (dateStr) return `Currently ${dateStr}`;
            return 'Pick a date and time slot';
        })();
        const totalSlotMinutes = (() => {
            const services = Array.isArray(appointment?.services) ? appointment.services : [];
            let total = 0;
            services.forEach((s) => { total += convertTimeToMinutes(s?.time_duration) || 0; });
            return total;
        })();
        return (
            <Box sx={{
                height:'100%',
                // Never grow past the parent: without this the time-slot list can
                // stretch the panel and carry the footer off the bottom of the screen.
                maxHeight:'100%',
                minHeight:0,
                width:'100%',
                background:'#fff',
                display:'flex',
                flexDirection:'column',
                overflow:'hidden',
            }}>
                {/* Header — compact title + subtitle (matches AddAppointmentNew) */}
                <Box sx={{position:'relative', display:'flex', alignItems:'flex-start', gap:1.5, px:{xs:2, sm:3}, py:2, borderBottom:'1px solid #F0CDDB', flexShrink:0}}>
                    {onBack && (
                        <IconButton onClick={() => onBack()} sx={{width:36, height:36, border:'1px solid #F0CDDB', borderRadius:'10px', color:'#A72C68', flexShrink:0, '&:hover':{background:'#FAEFF5', borderColor:'#A72C68'}}}>
                            <ArrowBackIcon sx={{fontSize:20}} />
                        </IconButton>
                    )}
                    <Box sx={{width:36, height:36, borderRadius:'10px', background:'#FAEFF5', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0}}>
                        <EventAvailableIcon sx={{color:'#A72C68'}} />
                    </Box>
                    <Box sx={{flex:1, minWidth:0}}>
                        <Typography sx={{fontSize:16, fontWeight:700, color:'#1a1a2e'}}>Change Date & Time</Typography>
                        <Typography sx={{fontSize:12, color:'#6B7280', mt:0.25}}>{headerSubtitle}</Typography>
                    </Box>
                    <IconButton onClick={() => onPanelClose?.()} sx={{width:32, height:32, border:'1px solid #F0CDDB', borderRadius:'8px', color:'#6B7280', '&:hover':{background:'#FAEFF5', color:'#A72C68'}}}>
                        <CloseIcon sx={{fontSize:18}} />
                    </IconButton>
                </Box>

                <Box sx={{flex:1, minHeight:0, overflow:'auto', p:{xs:2, sm:3}, position:'relative'}}>
                    {loading && <Waveloading cover />}
                        {/* Staff preference + treatment time row (matches AddAppointmentNew) */}
                        <Box sx={{
                            display:'flex', alignItems:'center', gap:2, flexWrap:'wrap',
                            p:1.5, mb:2,
                            borderRadius:'12px',
                            background:'#FAEFF5',
                            border:'1px solid #F0CDDB',
                        }}>
                            <Typography sx={{fontSize:13, fontWeight:700, color:'#A72C68'}}>Staff Preference</Typography>
                            <FormControlLabel
                                control={<Radio size="small" checked={!selectedStaff} onChange={() => setSelectedStaff(null)} sx={{color:'#A72C68', '&.Mui-checked':{color:'#A72C68'}}} />}
                                label="No preference"
                                sx={{'& .MuiFormControlLabel-label':{fontSize:13, color:'#374151'}, m:0}}
                            />
                            <Autocomplete
                                size="small"
                                sx={{
                                    minWidth:200, flex:1,
                                    background:'#fff',
                                    borderRadius:'10px',
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius:'10px',
                                        '& fieldset':{borderColor:'#F0CDDB'},
                                        '&:hover fieldset':{borderColor:'#A72C68'},
                                        '&.Mui-focused fieldset':{borderColor:'#A72C68'},
                                    },
                                }}
                                options={crmStaffs || []}
                                value={selectedStaff}
                                isOptionEqualToValue={(o, v) => o?.id === v?.id}
                                getOptionLabel={(o) => o?.name || ''}
                                renderInput={(params) => <TextField {...params} placeholder="Select Staff" />}
                                onChange={(e, v) => setSelectedStaff(v)}
                            />
                            {totalSlotMinutes > 0 && (
                                <Box sx={{ml:'auto', display:'flex', alignItems:'center', gap:0.5, px:1.25, py:0.5, background:'#fff', border:'1px solid #F0CDDB', borderRadius:'999px'}}>
                                    <AccessTimeFilledIcon sx={{fontSize:14, color:'#A72C68'}} />
                                    <Typography sx={{fontSize:12, color:'#A72C68', fontWeight:700}}>
                                        {totalSlotMinutes} min slot
                                    </Typography>
                                </Box>
                            )}
                        </Box>

                        {/* Calendar + time slots (existing component, functionality preserved) */}
                        <AppointmentTime
                            panelMode
                            selectedFinalDate={selectedFinalDate}
                            setSelectedFinalDate={setSelectedFinalDate}
                            selectedTime={selectedTime}
                            selectedStaff={selectedStaff}
                            setSelectedTime={setSelectedTime}
                            selectedServices={appointment?.services}
                            getAppointmentHoliday={getAppointmentHoliday}
                            getAppointmentSchedule={getAppointmentSchedule}
                            handleTimeSelect={handleTimeSelect}
                            executeScroll={executeScroll}
                        />
                    </Box>

                {/* Footer — hidden in hideFooter mode (parent commits selection on its own action) */}
                {!hideFooter && (
                    <Box sx={{
                        display:'flex',
                        // On phones the three items can't sit on one line — stacking keeps
                        // "Confirm Reschedule" on screen instead of wrapping it out of view.
                        flexDirection:{xs:'column', sm:'row'},
                        alignItems:{xs:'stretch', sm:'center'},
                        gap:1.25,
                        px:{xs:2, sm:2.5}, py:1.5,
                        pb:{xs:'calc(12px + env(safe-area-inset-bottom))', sm:1.5},
                        borderTop:'1px solid #F1F2F6', background:'#fff', flexShrink:0,
                        flexWrap:{xs:'nowrap', sm:'wrap'},
                    }}>
                        <Box sx={{display:'flex', alignItems:'center', gap:0.5, mr:{sm:'auto'}}}>
                            <FormControlLabel
                                control={<Checkbox checked={apiValue===1} onChange={handleCheckboxChange} sx={{p:0.5, color:'#d6d8de', '&.Mui-checked':{color:'#A72C68'}, '& .MuiSvgIcon-root':{fontSize:20}}} />}
                                label={<Typography sx={{fontSize:'13px', fontWeight:500, color:'#1a1a2e', ml:0.5}}>Send Notification</Typography>}
                                sx={{m:0}}
                            />
                            <InfoOutlinedIcon sx={{fontSize:14, color:'#8a8d97'}} />
                        </Box>
                        <Box sx={{display:'flex', alignItems:'center', gap:1.25, width:{xs:'100%', sm:'auto'}}}>
                            <Button
                                variant="outlined"
                                onClick={() => setNoteInlineView(true)}
                                startIcon={<TextSnippetIcon sx={{fontSize:'16px !important', color:'#A72C68'}} />}
                                sx={{
                                    background:'#fff', color:'#1a1a2e',
                                    border:'1px solid #ECEDF2',
                                    textTransform:'none', borderRadius:'10px',
                                    px:{xs:1.25, sm:2}, py:1, fontWeight:600, fontSize:'13px',
                                    flex:{xs:'1 1 auto', sm:'0 0 auto'},
                                    '&:hover':{background:'#F7F8FB', borderColor:'#D6D8DE'},
                                }}
                            >
                                Add a Note
                            </Button>
                            <Button
                                variant="contained"
                                disabled={!canSubmit}
                                onClick={handelRescheduleClick}
                                startIcon={<CalendarMonthIcon sx={{fontSize:'16px !important'}} />}
                                sx={{
                                    background:'#27AE60', color:'#fff',
                                    border:'1px solid #27AE60',
                                    textTransform:'none', borderRadius:'10px', px:{xs:1.25, sm:2}, py:1,
                                    fontWeight:600, fontSize:'13px',
                                    boxShadow:'none',
                                    flex:{xs:'1 1 auto', sm:'0 0 auto'},
                                    '&:hover':{background:'#fff', color:'#1E8449', border:'1px solid #27AE60', boxShadow:'none'},
                                    '&.Mui-disabled':{background:'#F0CDDB', color:'#fff'},
                                }}
                            >
                                Confirm Reschedule
                            </Button>
                        </Box>
                    </Box>
                )}
            </Box>
        );
    }

    return (
        <Box>

            { appointment?.id && <CustomModal
                customWidth={"60%"}
                open={rescheduleModal}
                setOpen={setRescheduleModal}   
            >
                 {/* {loading ? <Waveloading fullSize/>:''} */}
               <Box sx={{display:"flex", flexDirection:{lg:"row",sm:"column",xs:"column"} , justifyContent:'space-between',mb:'10px',mt:'10px' ,gap:"12px"}}>
                   <Typography
                       sx={{textAlign:'center', fontSize: {lg:"20px",sm:"16px",xs:"16px"},mt:"-6px",fontFamily:'helvetica-lt-std-bold'}}
                   >
                       Reschedule Appointment
                   </Typography>
                   { appointment?.date && 
                       <Typography
                           sx={{
                               textAlign: 'center',
                               fontSize: {lg:"20px",sm:"16px",xs:"16px"}, 
                               mt: "-6px",
                               fontFamily: 'helvetica-lt-std-bold',
                           }}  
                       >
                       Current Booking : {moment(appointment?.date).format('dddd, Do MMMM, YYYY')},{appointment?.start_time}
                   </Typography>
                   }

               </Box>
               <Box sx={{ width: '100%' }}>
  {crmStaffs?.length > 0 ? (
    <Tabs
      value={selectedStaff?.id || false}
      variant="scrollable"
      scrollButtons  
      allowScrollButtonsMobile
      onChange={(e, newValue) => {
        const selected = crmStaffs.find((staff) => staff.id === newValue);
        handleStaffSelection(selected);
      }}
      sx={{
        borderBottom: 1,
        borderColor: 'divider',
        mb: 3,
      }}
    >
      {crmStaffs.map((staff) => (
        <Tab
          key={staff.id}
          value={staff.id}
          label={
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Box sx={{ position: 'relative' }}>
                <Avatar
                  src={staff.profile_image}
                  variant="rounded" 
                  sx={{ width: 100, height: 100 }}
                />
                {selectedStaff?.id === staff.id && (
                  <CheckCircleIcon
                    sx={{
                      color: '#128D64',
                      fontSize: '28px',
                      position: 'absolute',
                      top: -10,
                      right: -10,
                      background: '#fff',
                      borderRadius: '50%',
                    }}
                  />
                )}
              </Box>
              <Typography sx={{ mt: 1, fontFamily: selectedStaff === staff?.id ? 'helvetica-lt-std-bold' : 'helvetica-lt-std-roman', }}>{staff.name}</Typography>
            </Box>
          }
          sx={{
            minWidth: 120,
            textTransform: 'none',
            padding: 2,
            display: 'flex',
            justifyContent: 'center',
          }}
        />
      ))}
    </Tabs>
  ) : (
    <Typography>No Staff Found</Typography>
  )}
</Box>
                <AppointmentTime  
                    selectedFinalDate={selectedFinalDate}
                    setSelectedFinalDate={setSelectedFinalDate}
                    selectedTime={selectedTime}   
                    selectedStaff={appointment?.staff || null}    
                    setSelectedTime={setSelectedTime} 
                    selectedServices={appointment?.services}
                    getAppointmentHoliday={getAppointmentHoliday}
                    getAppointmentSchedule={getAppointmentSchedule}
                    handleTimeSelect={handleTimeSelect}
                    executeScroll={executeScroll} 
                  

                />
                  <Box sx={{display:"flex",gap:"3",marginLeft:"19px"}}>
                                              <Box>
                                              <FormControlLabel
                                                            // key={index}
                                                            // value={method?.name}
                                                            size="small"      
                                                            control={
                                                                <Checkbox  
                                                                checked={apiValue === 1}
                                                                onChange={handleCheckboxChange}
                                                                />
                                                            }         
                                                            label={"Send Notification"}  
                                                            sx={{   
                                                               '& .MuiSvgIcon-root': {  
                                                                    fontSize: 20,  
                                                                      },
                                                            }}
                                                        />  

                                            </Box>

                                              <AddNotesModal  appointmentDetails={appointment}  appointment wid={"100%"}/>
                                            </Box>
                {
                    selectedTime?.start_time &&<Box  ref={rescheduleButtonRef} sx={{display:'flex',justifyContent:"center",mt:'24px'}}>
                    <CustomButton    handleClick={handelRescheduleClick} val={'Reschedule Appointment'} />
                </Box>
                }
                
              
            </CustomModal>}
            {loading ? (panelMode ? <Waveloading cover/> : <Waveloading fullSize/>):''}
            {isRequested ?
                <Button
                    variant="outlined"
                    color="info"
                    onMouseEnter={() => {
                        setIsMouseEnter(true)
                    }}
                    onMouseLeave={() => {
                        setIsMouseEnter(false)
                    }}
                    onClick={() => isMouseEnter && appointment?.id  && handleReschedule()}
                    sx={{
                        height:'100%'
                    }}
                >
                    Reschedule
                </Button>
                : isConfirm ?
                <Box sx={{ mt:4, }}>
                    <Typography
                        variant="h6"
                        color="initial"
                        sx={{
                            color:'#1565c0',
                            marginTop:'5px',
                            fontFamily: "helvetica-lt-std-bold",
                            cursor:'pointer',
                        }}
                        onClick={() =>appointment?.id  && handleReschedule()}
                    >
                        Reschedule appointment
                    </Typography>
                </Box>
                :
            <Customcolorbtn
                mainColor={"#ff5907"}
                handleClick={() =>appointment?.id  && handleReschedule()}
                style={{borderRadius: "4px", padding: '10px 15px', width: fwidth}}
                val={"Reschedule"}
                 icon={isbtn ? <EventRepeatIcon /> : null}    
            />
            }

        </Box>
    );
};

export default AppointmentCalender;